export type Operation<T, R = T> = (collection: T[]) => R[];

export interface ExplicitArrayWrapper<T> {
    pipe<R>(op: Operation<T, R>): ExplicitArrayWrapper<R>;

    pipe<R, R1>(op1: Operation<T, R>, op2: Operation<R, R1>): ExplicitArrayWrapper<R1>;

    pipe<R, R1, R2>(op1: Operation<T, R>, op2: Operation<R, R1>, op3: Operation<R1, R2>): ExplicitArrayWrapper<R2>;

    pipe<R, R1, R2, R3>(op1: Operation<T, R>, op2: Operation<R, R1>, op3: Operation<R1, R2>, op4: Operation<R2, R3>): ExplicitArrayWrapper<R3>;

    pipe<R, R1, R2, R3, R4>(op1: Operation<T, R>, op2: Operation<R, R1>, op3: Operation<R1, R2>, op4: Operation<R2, R3>, op5: Operation<R3, R4>): ExplicitArrayWrapper<R4>;

    pipe<R>(...ops: Operation<any, any>[]): ExplicitArrayWrapper<R>;

    value(): T[];
}

export function _wrap<T>(collection: T[]): ExplicitArrayWrapper<T> {
	return new Wrapper<T>(collection, [])
}

class Wrapper<T> implements ExplicitArrayWrapper<T> {

	constructor(
        private collection: T[],
        private operations: Operation<any, any>[] = [],
	) { }

	pipe(...operations: any[]): any {
		return new Wrapper(this.collection.slice(0), [...this.operations, ...operations])
	}

	value(): T[] {
		let collection = this.collection
		for (const op of this.operations) {
			collection = op(collection)
		}
		return collection
	}
}